<template>
  <span class="wrapper">
    <span class="origin"><slot /></span>
    <span class="stroke"><slot /></span>
  </span>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: 'white',
  },
  stroke: {
    type: String,
    default: 'black',
  },
})
</script>
<style lang="scss" scoped>
.wrapper {
  position: relative;
  display: inline-flex;
  // white-space: nowrap;
  color: v-bind(color);
  .stroke {
    -webkit-text-stroke: 0.2em v-bind(stroke);
  }
  .origin {
    position: absolute;
    z-index: 2;
  }
}
</style>
